import React, { type JSX, type ReactNode } from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import SettingsFeatureIconBox from './SettingsFeatureIconBox';

export type SettingsFeatureCardProps = {
  id?: string;
  headerIcon?: ReactNode;
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
  showBetaChip?: boolean;
};

const SettingsFeatureCard = ({
  id,
  headerIcon,
  title,
  subtitle,
  children,
  footer,
  showBetaChip = false,
}: SettingsFeatureCardProps): JSX.Element => {
  const titleId = id ? `${id}-title` : undefined;

  return (
    <Card id={id} sx={{ flex: 1 }}>
      <CardHeader
        avatar={headerIcon ? <SettingsFeatureIconBox>{headerIcon}</SettingsFeatureIconBox> : undefined}
        title={
          <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap' useFlexGap>
            <Typography id={titleId} variant='titleMedium' component='span'>
              {title}
            </Typography>
            {showBetaChip ? (
              <Chip label='Beta' variant='tonal' color='warning' size='small' sx={{ height: 22 }} />
            ) : null}
          </Stack>
        }
        subheader={subtitle}
        subheaderTypographyProps={{ variant: 'paragraphRegular', color: 'text.secondary' }}
        sx={{ pb: 1, pt: 2 }}
      />
      <CardContent sx={{ pt: 1, '&:last-child': { pb: 2 } }}>
        {children}
        {footer}
      </CardContent>
    </Card>
  );
};

export default SettingsFeatureCard;
